import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './spinner.css';

export const Spinner = ({
  showLoading = false,
  browserSupportsAnimations,
  loading,
  dataTest = 'mdtSpinner'
}) => {
  const [spinnerClassNames, setSpinnerClassNames] = useState('');

  useEffect(() => {
    setSpinnerClassNames(classNames({ visible: showLoading, 'mdt-general-loader': true }));
  }, [showLoading]);

  const renderContent = browserSupportsAnimations ? (
    <div data-test='loadingSpinner' className='center spinner'>
      <div className='bounce1'></div>
      <div className='bounce2'></div>
      <div className='bounce3'></div>
    </div>
  ) : (
    <div data-test='loadingText' className='center'>
      <span className='text'>{loading}</span>
    </div>
  );

  return (
    <div data-test={dataTest} className={spinnerClassNames}>
      <div className='outline'></div>
      {renderContent}
    </div>
  );
};

Spinner.propTypes = {
  showLoading: PropTypes.bool,
  browserSupportsAnimations: PropTypes.bool,
  loading: PropTypes.string,
  dataTest: PropTypes.string
};

export default Spinner;
